import { FormatUnixDate } from "utils/helpers/date_helpers";

export const AirTreeSimulationTableColumns = () => {

    return [
        {
            title: 'Sostanza.',
            dataIndex: 'substance',
            fixed: true,
            width: 100,
            className: 'text-center',
        },
        {
            title: 'Label',
            dataIndex: 'label',
        },
        {
            title: 'U.m.',
            dataIndex: 'um',
        },
        {
            title: 'Tot/m2',
            dataIndex: 'totm2',
            render: (record) => record?.toFixed(5)
        },
        {
            title: 'Tot/tree',
            dataIndex: 'totTree',
            render: (record) => record?.toFixed(3)
        },
        // {
        //     title: 'Tot/specie',
        //     dataIndex: 'totType',
        // }
    ]
};